import React from 'react'

export default function TitleH2({title}: { title: string }) {
    return (
        <h2 className="title-h2">
            {title}
        </h2>
    )
}
